import React from 'react'

const CircleIcon83pxSvg = (props) => {
    return (
        <svg 
        {...props}
        width="83" height="83" viewBox="0 0 83 83" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M41.1513 82.1035C18.4973 82.1401 0.102993 63.8052 0.0663466 41.1513C0.0297006 18.4973 18.3646 0.102999 41.0186 0.0663535C63.6725 0.0297075 82.0668 18.3646 82.1035 41.0186C82.1401 63.6725 63.8052 82.0668 41.1513 82.1035ZM41.0339 9.56178C23.6242 9.58995 9.53362 23.7262 9.56178 41.1359C9.58994 58.5456 23.7262 72.6362 41.1359 72.608C58.5456 72.5799 72.6362 58.4437 72.608 41.0339C72.5799 23.6242 58.4437 9.53362 41.0339 9.56178Z" fill="#19293C" />
        </svg>

    )
}

export default CircleIcon83pxSvg